var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("Pagination", {
    attrs: {
      resultFrom: _vm.fromPageNumber,
      resultTo: _vm.toPageNumber,
      total: _vm.config.total,
      containerClass: _vm.containerClass,
      showmeta: _vm.showmeta,
    },
    on: { next: _vm.next, prev: _vm.prev },
    scopedSlots: _vm._u([
      {
        key: "dropdown",
        fn: function () {
          return [
            _c("div", { staticClass: "ml-auto mr-3 max-w-sm" }, [
              _c(
                "select",
                {
                  staticClass:
                    "block form-select w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                  attrs: { id: "invitation-limit" },
                  domProps: { value: _vm.config.limit },
                  on: { input: (e) => _vm.updatedLimit(e.target.value) },
                },
                [
                  _c("option", { domProps: { value: 5 } }, [
                    _vm._v("5 per page"),
                  ]),
                  _c("option", { domProps: { value: 8 } }, [
                    _vm._v("8 per page"),
                  ]),
                  _c("option", { domProps: { value: 15 } }, [
                    _vm._v("15 per page"),
                  ]),
                  _c("option", { domProps: { value: 25 } }, [
                    _vm._v("25 per page"),
                  ]),
                  _c("option", { domProps: { value: 50 } }, [
                    _vm._v("50 per page"),
                  ]),
                ]
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }